import { FormBase } from "core/components";

export default class NoteEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "note",
                    label: "NOTE.EDIT.NOTE_LABEL",
                    placeholder: "NOTE.EDIT.NOTE_PLACEHOLDER",
                    rules: "required|string"
                }
            ],
        };
    }
}